import { AppFC } from '@types';
import { Image } from '@kit/image';
import { CallSetupSceneBodyStyled, CallSetupSceneDecimalListItemStyled, CallSetupSceneDecimalListStyled, CallSetupSceneDesktopStyled, callSetupSceneImageClassName, CallSetupSceneImageWrapStyled, CallSetupSceneMobileStyled, CallSetupSceneNoteStyled, CallSetupSceneParagraphStyled, CallSetupSceneSectionStyled, CallSetupSceneStyled, CallSetupSceneTabletStyled, CallSetupSceneTitleStyled, microphoneAccessImageClassName, MoreIconStyled, siteSettingsImageClassName } from './styled';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export const CallSetupScene: AppFC = () => {
  return _jsxs(CallSetupSceneStyled, {
    children: [_jsx(CallSetupSceneTitleStyled, {
      children: "\u041A\u0430\u043A \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043C\u0435\u0440\u0435 \u0438 \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443"
    }), _jsx(CallSetupSceneBodyStyled, {
      children: _jsxs(CallSetupSceneSectionStyled, {
        children: [_jsx(CallSetupSceneMobileStyled, {
          children: _jsxs(CallSetupSceneDecimalListStyled, {
            children: [_jsx(CallSetupSceneDecimalListItemStyled, {
              children: _jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 Chrome \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 Android \u043D\u0430\u0436\u043C\u0438\u0442\u0435", _jsx(MoreIconStyled, {}), "\u0432 \u043F\u0440\u0430\u0432\u043E\u043C \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u0443\u0433\u043B\u0443."]
              })
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043E\u0442\u043A\u0440\u044B\u0432\u0448\u0435\u043C\u0441\u044F \u043C\u0435\u043D\u044E \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u043C ", _jsx("strong", {
                  children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438."
                })]
              }), _jsx(Image, {
                className: callSetupSceneImageClassName,
                src: "/images/call-setup/microphone-settings.png",
                alt: 'Настройки микрофона',
                loaderDisabled: true
              })]
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043E\u0442\u043A\u0440\u044B\u0432\u0448\u0435\u043C\u0441\u044F \u043C\u0435\u043D\u044E \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ", _jsx("strong", {
                  children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0441\u0430\u0439\u0442\u043E\u0432."
                })]
              }), _jsx(CallSetupSceneImageWrapStyled, {
                children: _jsx(Image, {
                  className: callSetupSceneImageClassName,
                  src: "/images/call-setup/site-settings-android.png",
                  alt: 'Настройки сайтов',
                  loaderDisabled: true
                })
              })]
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u041D\u0430\u0436\u043C\u0438\u0442\u0435 ", _jsx("strong", {
                  children: "\u041C\u0438\u043A\u0440\u043E\u0444\u043E\u043D."
                })]
              }), _jsx(Image, {
                className: callSetupSceneImageClassName,
                src: "/images/call-setup/microphone-disabled.png",
                alt: 'Микрофон заблокирован',
                loaderDisabled: true
              })]
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043E\u0442\u043A\u0440\u044B\u0432\u0448\u0435\u043C\u0441\u044F \u043E\u043A\u043D\u0435", ' ', _jsx("strong", {
                  children: "\u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u043F\u043E\u043B\u0437\u0443\u043D\u043E\u043A \u0432\u043F\u0440\u0430\u0432\u043E"
                }), " \u0434\u043B\u044F \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438."]
              }), _jsx(CallSetupSceneImageWrapStyled, {
                children: _jsx(Image, {
                  className: callSetupSceneImageClassName,
                  src: "/images/call-setup/microphone-active.png",
                  alt: 'Разрешен доступ к микрофону',
                  loaderDisabled: true
                })
              })]
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0417\u0430\u0442\u0435\u043C \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u044D\u0442\u043E \u0434\u043B\u044F ", _jsx("strong", {
                  children: "\u041A\u0430\u043C\u0435\u0440\u044B."
                })]
              }), _jsxs(CallSetupSceneNoteStyled, {
                children: ["\u0415\u0441\u043B\u0438 \u043D\u0443\u0436\u043D\u044B\u0439 \u0441\u0430\u0439\u0442 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043A\u0435 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043D\u0435\u0433\u043E \u0438 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ", '>', " \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443 ", '>', " \u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C."]
              })]
            })]
          })
        }), _jsx(CallSetupSceneTabletStyled, {
          children: _jsxs(CallSetupSceneDecimalListStyled, {
            children: [_jsx(CallSetupSceneDecimalListItemStyled, {
              children: _jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 Chrome \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 Android \u043D\u0430\u0436\u043C\u0438\u0442\u0435", _jsx(MoreIconStyled, {}), "\u0432 \u043F\u0440\u0430\u0432\u043E\u043C \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u0443\u0433\u043B\u0443."]
              })
            }), _jsx(CallSetupSceneDecimalListItemStyled, {
              children: _jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043E\u0442\u043A\u0440\u044B\u0432\u0448\u0435\u043C\u0441\u044F \u043C\u0435\u043D\u044E \u0432\u044B\u0431\u0438\u0440\u0430\u0435\u043C ", _jsx("strong", {
                  children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438."
                })]
              })
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043E\u0442\u043A\u0440\u044B\u0432\u0448\u0435\u043C\u0441\u044F \u043C\u0435\u043D\u044E \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ", _jsx("strong", {
                  children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0441\u0430\u0439\u0442\u043E\u0432."
                })]
              }), _jsxs(CallSetupSceneImageWrapStyled, {
                children: [_jsx(Image, {
                  className: callSetupSceneImageClassName,
                  src: "/images/call-setup/microphone-settings.png",
                  alt: 'Настройки микрофона',
                  loaderDisabled: true
                }), _jsx(Image, {
                  className: callSetupSceneImageClassName,
                  src: "/images/call-setup/site-settings-android.png",
                  alt: 'Настройки сайтов',
                  loaderDisabled: true
                })]
              })]
            }), _jsx(CallSetupSceneDecimalListItemStyled, {
              children: _jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u041D\u0430\u0436\u043C\u0438\u0442\u0435 ", _jsx("strong", {
                  children: "\u041C\u0438\u043A\u0440\u043E\u0444\u043E\u043D."
                })]
              })
            }), _jsx(CallSetupSceneDecimalListItemStyled, {
              children: _jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u043E\u0442\u043A\u0440\u044B\u0432\u0448\u0435\u043C\u0441\u044F \u043E\u043A\u043D\u0435", ' ', _jsx("strong", {
                  children: "\u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u043F\u043E\u043B\u0437\u0443\u043D\u043E\u043A \u0432\u043F\u0440\u0430\u0432\u043E"
                }), " \u0434\u043B\u044F \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438."]
              })
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0417\u0430\u0442\u0435\u043C \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u044D\u0442\u043E \u0434\u043B\u044F ", _jsx("strong", {
                  children: "\u041A\u0430\u043C\u0435\u0440\u044B."
                })]
              }), _jsxs(CallSetupSceneImageWrapStyled, {
                children: [_jsx(Image, {
                  className: callSetupSceneImageClassName,
                  src: "/images/call-setup/microphone-disabled.png",
                  alt: 'Микрофон заблокирован',
                  loaderDisabled: true
                }), _jsxs("div", {
                  children: [_jsx(Image, {
                    className: callSetupSceneImageClassName,
                    src: "/images/call-setup/microphone-active.png",
                    alt: 'Разрешен доступ к микрофону',
                    loaderDisabled: true
                  }), _jsxs(CallSetupSceneNoteStyled, {
                    children: ["\u0415\u0441\u043B\u0438 \u043D\u0443\u0436\u043D\u044B\u0439 \u0441\u0430\u0439\u0442 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043A\u0435 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043D\u0435\u0433\u043E \u0438 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ", '>', " \u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D\u0443 ", '>', ' ', "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C."]
                  })]
                })]
              })]
            })]
          })
        }), _jsx(CallSetupSceneDesktopStyled, {
          children: _jsxs(CallSetupSceneDecimalListStyled, {
            children: [_jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u0412 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0435 \u0441\u043B\u0435\u0432\u0430 \u043E\u0442 \u0430\u0434\u0440\u0435\u0441\u0430 \u0441\u0430\u0439\u0442\u0430 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430", ' ', _jsx("strong", {
                  children: "\u0437\u0430\u043C\u043E\u0447\u0435\u043A"
                }), ", \u0438 \u043F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0432", ' ', _jsx("strong", {
                  children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0441\u0430\u0439\u0442\u0430."
                })]
              }), _jsx(Image, {
                className: siteSettingsImageClassName,
                src: "/images/call-setup/site-settings.png",
                alt: 'Настройки сайта',
                loaderDisabled: true
              })]
            }), _jsxs(CallSetupSceneDecimalListItemStyled, {
              children: [_jsxs(CallSetupSceneParagraphStyled, {
                children: ["\u041D\u0430\u043F\u0440\u043E\u0442\u0438\u0432 \u043F\u0443\u043D\u043A\u0442\u043E\u0432 ", _jsx("strong", {
                  children: "\u041A\u0430\u043C\u0435\u0440\u0430"
                }), " \u0438", ' ', _jsx("strong", {
                  children: "\u041C\u0438\u043A\u0440\u043E\u0444\u043E\u043D"
                }), " \u0432 \u0432\u044B\u043F\u0430\u0434\u0430\u044E\u0449\u0435\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 ", _jsx("strong", {
                  children: "\xAB\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C\xBB."
                })]
              }), _jsx(Image, {
                className: microphoneAccessImageClassName,
                src: "/images/call-setup/microphone-access.png",
                alt: 'Доступ к микрофону',
                loaderDisabled: true
              })]
            })]
          })
        })]
      })
    })]
  });
};